import { AxiosInstance } from 'axios';

import { ExternalConnectionsAPIApiFactory } from '@cast/openapi-permissions-center';

import { AXIOS_CONFIGURATION } from '../constants';

export const PermissionsCenterApiFactory = (client: AxiosInstance) => {
  const externalConnectionsApi = ExternalConnectionsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    listFeatures: externalConnectionsApi.externalConnectionsAPIListFeatures,
    listPermissions:
      externalConnectionsApi.externalConnectionsAPIComputePermissions,
  };
};
